"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (_a) {
    var _b = _a === void 0 ? {} : _a, taskId = _b.taskId, task = _b.task;
    var device = virtual.device;
    var subDevice = virtual.subDevice;
    return {
        action: 'timerReport',
        msgId: virtual.msgId,
        params: {
            code: 200,
            devTid: device.devTid,
            subDevTid: subDevice.devTid || undefined,
            task: task,
            taskId: taskId
        }
    };
}; });



// WEBPACK FOOTER //
// ./src/actions/send/actions/timerReport.ts